<template>
  <pp-app
    :style="cssVars"
  >
    <div
      v-if="isUnsupportedBrowser"
      class="pa-5"
      flat
    >
      <p>Your browser isn't supported for video visits. Please try updating your current browser or select a supported browser:</p>
      <ul>
        <li>Google Chrome (latest release version on Desktop and Android)</li>
        <li>Firefox (latest release version)</li>
        <li>Microsoft Edge (version 79+)</li>
        <li>Safari 11 on macOS and Safari on iOS 11.</li>
        <li>Opera (latest release version)</li>
      </ul>
    </div>
    <div
      v-else-if="isLoading"
      :loading="true"
      class="text-center align-center justify-center"
    />
    <span v-else-if="!isEntitlementEnabled">
      There was a problem accessing virtual visit
    </span>
    <router-view
      v-else
      :key="$route.fullPath"
    />
  </pp-app>
</template>
<script>
import Vuex from 'vuex'
import { reportLoadedSuccessfully } from 'sdk-widget-manager'
import { datadogRum } from '@datadog/browser-rum'

const DROP_IN_SESSION_ENTITLEMENT = 'session-management.create-drop-in'
const { mapGetters } = Vuex
export default {
  name: 'App',
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters({
      isPracticeEntitlementEnabled: 'entitlements/isPracticeEntitlementEnabled',
      entitlements: 'entitlements/entitlements'
    }),
    isEntitlementEnabled () {
      return this.isPracticeEntitlementEnabled(DROP_IN_SESSION_ENTITLEMENT)
    },
    isUnsupportedBrowser () {
      const browserInfo = this.$browserDetect
      const browserVersion = parseInt(this.$browserDetect.meta.version)

      return (browserInfo.isChromeIOS) ||
        (browserInfo.isChrome && !browserInfo.isOpera && browserVersion < 80) ||
        (browserInfo.isFirefox && browserVersion < 76) ||
        (browserInfo.isIE) ||
        (browserInfo.isEdge && browserVersion < 79) ||
        (browserInfo.isSafari && browserVersion < 11) ||
        (browserInfo.isOpera && browserVersion < 67)
    },
    cssVars () {
      let cssVars = ''
      if (this.$ppColors.primary) {
        cssVars += `--pp-theme-color:${this.$ppColors.primary};`
      }
      return cssVars
    }
  },
  watch: {
    entitlements () {
      this.isLoading = false
    }
  },
  mounted () {
    try {
      reportLoadedSuccessfully(DROP_IN_SESSION_ENTITLEMENT)
    } catch (e) {
      datadogRum.addError(e, { component: 'AppLoading' })
    }
    if (this.$route.params.noPracticeUuid) {
      this.isLoading = false
    }
  }
}
</script>
<style lang="scss">
  html {
    body {
      .v-application--wrap {
        min-height: auto;
      }
    }
  }
</style>
